import { FoodCategory } from '@/root/types';
import * as React from 'react';

export interface NavMenuButton {
  category: FoodCategory;
  activeSection?: Boolean | null;
  onMenuClick: (index: number) => void;
  index: number;
}

export const NavMenuButton = (props: NavMenuButton) => {
  const { category, activeSection, onMenuClick, index, ...other } = props;

  return (
    <button onClick={() => onMenuClick(index)}
    className={`menuNavButton ${activeSection ? 'active' : ''}`}>
      <div className='catName'>{category.name}</div>
    </button>
  );
};